// @charset "utf-8";
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import api from '@/api'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

import vueGlobalConfig from '@/lib/vueGlobalConfig'

Vue.prototype.$api = api

Vue.config.productionTip = false

new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js